/**
 * URLが画像ファイルかどうか判定
 */
export const isImageFile = (url: string): boolean => {
  const imageExtensions = ['.jpg', '.jpeg', '.png']
  const lowercaseUrl = url.toLowerCase()
  return imageExtensions.some((ext) => lowercaseUrl.includes(ext))
}

/**
 * URLからファイル名を抽出
 */
export const getFileName = (url: string): string => {
  const urlWithoutQuery = url.split('?')[0]
  const parts = urlWithoutQuery.split('/')
  const fileName = parts[parts.length - 1]

  // デコードして返す
  try {
    return decodeURIComponent(fileName)
  } catch {
    return fileName
  }
}
